import { render, staticRenderFns } from "./UserWelcome.vue?vue&type=template&id=6fa63b02&scoped=true"
import script from "./UserWelcome.vue?vue&type=script&lang=js"
export * from "./UserWelcome.vue?vue&type=script&lang=js"
import style0 from "./UserWelcome.vue?vue&type=style&index=0&id=6fa63b02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa63b02",
  null
  
)

export default component.exports